import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [error, setError] = useState("");
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    (async () => {
      if (!sessionId) {
        navigate("/login");
        return;
      }
      try {
        const codigo = sessionStorage.getItem("aldia-codigo-invitacion") || "";
        sessionStorage.removeItem("aldia-codigo-invitacion");
        const { data } = await api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sessionId, ...(codigo ? { "X-Codigo-Invitacion": codigo } : {}) } });
        setUser(data);
        window.history.replaceState(null, "", window.location.origin + "/");
        navigate("/");
      } catch (e) {
        const beta = e.response?.status === 403;
        setError(beta ? e.response.data.detail : "No hemos podido iniciar sesión con Google. Inténtalo de nuevo.");
        setTimeout(() => navigate(beta ? "/register" : "/login"), beta ? 6000 : 2500);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#FAF8F5] flex flex-col items-center justify-center gap-4 px-6 text-center">
      {!error ? (
        <>
          <div className="w-14 h-14 rounded-full border-4 border-[#E5DFD5] border-t-[#3A6B56] animate-spin" />
          <p className="text-base text-[#6E7A74]">Iniciando sesión con Google…</p>
        </>
      ) : (
        <p className="text-base font-semibold text-[#B91C1C]">{error}</p>
      )}
    </div>
  );
}
